import NRResizableDrawer from '../NRResizableDrawer/NRResizableDrawer';
import NRActivityFeedContainer from './NRActivityFeedContainer';

function NRActivityFeed({ openDrawer, handleClose }) {
  return (
    <NRResizableDrawer
      open={openDrawer}
      onClose={handleClose}
      title="Activity Feed"
      width={650}
      contentPadding={0}
      storageKey="ActivityFeedDrawer"
      backgroundColor="background.paper"
    >
      <NRActivityFeedContainer handleClose={handleClose} />
    </NRResizableDrawer>
  );
}
export default NRActivityFeed;
